import { error, message, warning, success, info } from 'react-toastify-redux'
import { intl } from 'i18n'

const config = {}

export const alertSuccess = (msg) => success(msg, config)
export const alertError = (msg) => error(msg, config)
export const alertMessage = (msg) => message(msg, config)
export const alertWarning = (msg) => warning(msg, config)
export const alertInfo = (msg) => info(msg, config)

export const alertErrorDefault = () => alertError(intl.formatMessage({ id: 'ducks.alert.errorDefault' }))
